import { call, put, takeLatest } from 'redux-saga/effects';
import types from '../actions/graph.actions';
import { storeSearchEntities, storeSearchDocuments, storeSearchConnectorEntities } from '../actions/graph.actions';
import api from "../../../../api/api";

export function* saveGraph() {
    yield takeLatest(types.INTELLIGENCE_SAVE_GRAPH, takeLatestSaveGraph);
}

function* takeLatestSaveGraph({ payload }) {
    let url = (!payload.graph.id) ? '/v1/grafo' : `/v1/grafo/${payload.graph.id}`;
    let response = yield call((!payload.graph.id) ? api.post : api.put, url, payload.graph);

    if (response.status === 200) {
        if (payload.onSuccess){
            payload.onSuccess(response.data);
        }
    } else {
        if (payload.onError){
            payload.onError(response.data);
        }
    }
}

export function* loadMyGraphs() {
    yield takeLatest(types.INTELLIGENCE_LOAD_MY_GRAPHS, takeLatestLoadMyGraphs);
}

function* takeLatestLoadMyGraphs({ payload }) {
    let response = yield call(api.get, `/v1/grafoByOwner`);

    if (response.status === 200) {
        if (payload.onSuccess){
            payload.onSuccess(response.data);
        }
    } else {
        if (payload.onError){
            payload.onError(response.data);
        }
    }
}

export function* loadSharedGraphs() {
    yield takeLatest(types.INTELLIGENCE_LOAD_SHARED_GRAPHS, takeLatestLoadSharedGraphs);
}

function* takeLatestLoadSharedGraphs({ payload }) {
    let response = yield call(api.get, `/v1/grafoSharedWithMe`);

    if (response.status === 200) {
        if (payload.onSuccess){
            payload.onSuccess(response.data);
        }
    } else {
        if (payload.onError){
            payload.onError(response.data);
        }
    }
}

export function* deleteGraph() {
    yield takeLatest(types.INTELLIGENCE_DELETE_GRAPH, takeLatestDeleteGraph);
}

function* takeLatestDeleteGraph({ payload }) {
    let response = yield call(api.delete, `/v1/grafo/${payload.id}`);

    if (response.status === 200) {
        if (payload.onSuccess){
            payload.onSuccess(response.data);
        }
    } else {
        if (payload.onError){
            payload.onError(response.data);
        }
    }
}

export function* getSearchEntities() {
    yield takeLatest(types.INTELLIGENCE_SEARCH_ENTITIES, takeLatestResultsSearchEntities);
}

export function* getSearchExpandEntities() {
    yield takeLatest(types.INTELLIGENCE_SEARCH_EXPAND_ENTITIES, takeLatestResultsSearchExpandEntities);
}

export function* getExpandByIdentificationDinardapEntities() {
    yield takeLatest(types.INTELLIGENCE_EXPAND_DINARDAP_ENTITIES, takeLatestResultsSearchExpandEntities);
}

function* takeLatestResultsSearchEntities({ payload }) {
    const response = yield call(api.post, `/v1/inteligencia/busqueda`, payload);
    yield put(storeSearchEntities(response.data));
}

function* takeLatestResultsSearchExpandEntities({ payload }) {
    const response = yield call(api.post, `/v1/inteligencia/busqueda/conector`, payload);
    yield put(storeSearchEntities(response.data));
}